import React from 'react';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import { theme } from './theme';
import { useNavigation } from './hooks/useNavigation';
import { WaterBackground } from './components/background/WaterBackground';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { HeroSection } from './components/sections/HeroSection';
import { AboutSection } from './components/sections/AboutSection';
import { CoursesSection } from './components/sections/CoursesSection';
import { ApproachSection } from './components/sections/ApproachSection';
import { WhyUsSection } from './components/sections/WhyUsSection';
import { ProgressSection } from './components/sections/ProgressSection';
import { ParentsSection } from './components/sections/ParentsSection';
import { ContactSection } from './components/sections/ContactSection';

const App: React.FC = () => {
  const { scrollToSection } = useNavigation();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <WaterBackground />
      <Box sx={{ position: 'relative', zIndex: 1 }}>
        <Header scrollToSection={scrollToSection} />

        <Box component="main">
          <HeroSection scrollToSection={scrollToSection} />
          <AboutSection />
          <CoursesSection />
          <ApproachSection />
          <WhyUsSection />
          <ProgressSection />
          <ParentsSection />
          <ContactSection />
        </Box>

        <Footer />
      </Box>
    </ThemeProvider>
  );
};

export default App;